/**
 * "Register payment device" — which registration flow serves which reader kind.
 *
 * The chooser is DRIVEN BY THE MODEL'S POLICY: a flow appears when the policy
 * lists one of its kinds, and is selectable when one of those kinds is enabled
 * and the flow exists. A new vendor = a new entry here (plus its lane) —
 * nothing else branches on a vendor.
 */
import type { CardSetupPolicy, ReaderKind } from './cardSetupModel';

export type RegistrationFlowId = 'tap_to_pay' | 'p_series' | 'magtek' | 'sunbay';

export interface RegistrationFlow {
  id: RegistrationFlowId;
  kinds: ReaderKind[];
  title: string;
  desc: string;
  /** False = no registration flow built yet ("Coming next"). */
  built: boolean;
  /** Payment configs the flow may register as (P-series routes). */
  configIds?: string[];
}

export const REGISTRATION_FLOWS: readonly RegistrationFlow[] = [
  { id: 'tap_to_pay', kinds: ['tap_to_pay'], title: 'Android Tap to Pay (SoftPOS)', desc: 'Contactless on this till — credit cards and wallets, tap only.', built: true },
  { id: 'p_series', kinds: ['dejavoo_p'], title: 'Dejavoo P Series', desc: 'Countertop reader with PIN pad — USB or SPIn Cloud.', built: true, configIds: ['dejavoo_spin_usb', 'dejavoo_spin_cloud'] },
  { id: 'magtek', kinds: ['magtek_ped', 'magtek_go'], title: 'MagTek devices', desc: 'DynaFlex II readers (PED or Go) over USB.', built: true },
  { id: 'sunbay', kinds: ['sunbay_tapro'], title: 'RubyTill Pay CPad', desc: 'SUNMI CPad Pay running RubyTill Pay — customer screen and card reader, cabled to the till.', built: true },
];

export interface RegistrationChoice extends RegistrationFlow { enabled: boolean }

/** The chooser's entries for this model's policy, in a fixed order. */
export function registrationChoices(policy: CardSetupPolicy): RegistrationChoice[] {
  return REGISTRATION_FLOWS
    .filter((f) => policy.readers.some((r) => f.kinds.includes(r.kind) && (r.primary || r.backup)))
    .map((f) => ({ ...f, enabled: f.built && policy.readers.some((r) => f.kinds.includes(r.kind) && r.enabled && (r.primary || r.backup)) }));
}
